import { render, staticRenderFns } from "./orderPickDetail.vue?vue&type=template&id=8e1dca18&scoped=true"
import script from "./orderPickDetail.vue?vue&type=script&lang=js"
export * from "./orderPickDetail.vue?vue&type=script&lang=js"
import style0 from "./orderPickDetail.vue?vue&type=style&index=0&id=8e1dca18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1dca18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e1dca18')) {
      api.createRecord('8e1dca18', component.options)
    } else {
      api.reload('8e1dca18', component.options)
    }
    module.hot.accept("./orderPickDetail.vue?vue&type=template&id=8e1dca18&scoped=true", function () {
      api.rerender('8e1dca18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/orderPickDetail.vue"
export default component.exports